import React from "react";

import Image from "next/image";
import Link from "next/link";

import ThemeButton from "@/app/(Global)/ThemeButton";
import styling from './AuthHeader.module.scss'


const AuthHeader = () => {
  return (
    <header className={`${styling.authHeader}`}>
      <div>
        <Link href="/">
          <span>
            <Image
              src="https://ik.imagekit.io/vinnie/BLOG/Vinnie-tec_62aUaX5Hu.png?updatedAt=1684410998966"
              alt="Vinnietec-Logo"
              width={450}
              height={450}
            />
          </span>
          <span>
            <strong>Blog</strong>
          </span>
        </Link>
      </div>
      <div>
        <span>
          <ThemeButton />
        </span>
      </div>
    </header>
  );
};

export default AuthHeader;
